export const ADMIN_PANEL_INIT = "ADMIN_PANEL_INIT";

export const ADMIN_PANEL_FETCH_BEGIN = "ADMIN_PANEL_FETCH_BEGIN";
export const ADMIN_PANEL_FETCH_FAIL = "ADMIN_PANEL_FETCH_FAIL";

export const ADMIN_STATUS_UPDATE = "ADMIN_STATUS_UPDATE";